import { mc } from './mc.js'
import router from './../router'
import axios from 'axios'
import wx from 'weixin-js-sdk'
import { Toast } from 'vant';


const errorMsg = {
  'noterm': {
      'type': 1, //not alert
      'text': '新学期还未开始'
  },
}

var Util = function () {
  this.loadJS = (url) => {
    return new Promise((resolve) => {
      const script = document.createElement('script')
      script.src = url
      script.type = 'text/javascript'
      document.body.appendChild(script)
      script.onload = () => {
        resolve()
      }
    })
  }
  this.Erequest = (callback) => {
    console.log(1);
    if (mc.isClient()) {
      console.log(2);
      mc.userGetEncryptInfo((data) => {
        if (data['state']) {
          callback(data)
        } else {
          mc.reLogin(() => {
            this.Erequest(callback)
          })
        }
      })
    } else {
        Toast('请在客户端内查看')
    }
  }
  this.ArequestSafe = (callback) => {
    var ua = window.navigator.userAgent || ''
    var ver = ua.split('com.cmstop.shaoxing')
    var needUpdate = false
    if (ver[1]) {
      ver = ver[1].replace(/\.|\)/g,'')
      needUpdate = parseInt(ver) < 534
    } else {
      needUpdate = true
    }
    if (!needUpdate) {
        mc.userGetInfo((data) => {
          if (data['state']) {
            mc.cmstopToGetToken(res => {
                if (res.state && res.data) {
                    callback({
                        'userid': data['data']['id'],
                        'token': res.data['token'].replace(/\n/g, ''),
                        'avatar': data.data['avatar']
                    })
                }
            })
            
          }
        })
      }
  }
  this.Arequest = (callback) => {
    var ua = window.navigator.userAgent || ''
    var ver = ua.split('com.cmstop.shaoxing')
    var needUpdate = false
    if (ver[1]) {
      ver = ver[1].replace(/\.|\)/g,'')
      needUpdate = parseInt(ver) < 534
    } else {
      needUpdate = true
    }
    if (!needUpdate) {
        mc.userGetInfo((data) => {
          if (data['state']) {
            mc.cmstopToGetToken(res => {
                if (res.state && res.data) {
                    callback({
                        'userid': data['data']['id'],
                        'token': res.data['token'].replace(/\n/g, ''),
                        'avatar': data.data['avatar']
                    })
                }
            })
            
          } else {
            mc.reLogin(() => {
              this.Arequest(callback)
            })
          }
        })
      } else {
          Toast('请在最新版越牛新闻APP中查看')
      }
  }
  this.openContentView = (contentid,appid) => {
    if (mc.isClient()) {
      mc.openContentView({
        contentid,
        appid,
        siteid: 10001,
        type: 1
      })
    } else {
      if (appid == 1) {
        router.push('/content/'+contentid)
      } else {
        Toast('请在客户端内查看')
      }
    }
  }
  this.openLinkView = (url) => {
    if (mc.isClient()) {
      mc.pushLinkViewController(url)
    } else {
      location.href = url
    }
  }
  this.inWechat = () => {
    return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
  }
  this.getSession = (name) => {
    return sessionStorage.getItem(name)
  }
  this.setSession = (name, value) => {
    sessionStorage.setItem(name, value)
  }
  this.setWxShareConfig = (config) => {
    var url = location.href.split('#')[0]
    axios.post('//bbs.sxnews.cn/server/api/wechat/officialaccount/ynxw/getshareconfig', {url}).then((res) => {
      if (res.status === 200) {
        wx.config({
          debug: false,
          appId: res.data.appId,
          timestamp: res.data.timestamp,
          nonceStr: res.data.nonceStr,
          signature: res.data.signature,
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
        })
        wx.ready(() => {
          wx.updateAppMessageShareData({
            title: config.title,
            desc: config.desc,
            link: config.url,
            imgUrl: config.imgUrl,
            success: function () {
              config.callback()
            }
          })
          wx.updateTimelineShareData({
            title: config.title,
            link: config.url,
            imgUrl: config.imgUrl,
            success: function () {
              config.callback()
            }
          })
        })
        wx.error(() => {
        })
      }
    })
  }
  this.getCookie = (name) => {
    name += '='
    var ca = document.cookie.split(';')
    let r = ca.map(c => {
      c = c.trim()
      if (c.indexOf(name)==0)
      return c.substring(name.length,c.length)
    })
    return r[0] ? r[0] : ''
  }
  this.deleteCookie = (name) => {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT'
  }
}
var util = new Util()

export {
  mc,
  util,
  errorMsg
}
